var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "investors" }, [
    _c("div", { staticClass: "investors__image" }),
    _vm._v(" "),
    _c("div", { staticClass: "investors__col" }, [
      _c("div", { staticClass: "investors__content" }, [_c("stock-data")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "investors__article" },
        [
          _c("h2", { staticClass: "investors__header" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "investors__text" }, [
            _vm._v(_vm._s(_vm.text)),
          ]),
          _vm._v(" "),
          _c(
            "z-button",
            {
              attrs: {
                tag: "a",
                href: "/" + _vm.$root.lang + "/investors/key-figures/",
                kind: "text",
              },
              scopedSlots: _vm._u([
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c("z-icon", {
                        attrs: {
                          name: "arrow_long",
                          dir: "right",
                          width: "40",
                          height: "24",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.button) + "\n                "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }